import axios from "axios";

export default {
    async getDipendenti() {
        const data = new FormData();
        data.append("dipendenti_attivo", "1");

        const response = await axios.post(`rest/v1/search/dipendenti`, data, {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        //console.log(response);
        return response;
    },
};
